/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TipoPraticaTemplate } from './tipo-pratica-template';


export interface CreaTipoPraticaDaTemplateRequestDTO { 
    template: TipoPraticaTemplate;
    codice: string;
    comune_id: string;
}



